import { ToastService } from "@shared/lib/services";
import {
  IFinanceApprovalLotsRequest,
  IFinanceApprovalLotsResponse,
} from "@shared/lib/types/finance";
import { BackednResponse } from "@shared/lib/types/response";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { FINANCE_APPROVAL_QUERY_KEY } from "../constants";
import { FinanceApprovalService } from "../services/FinanceApprovalService";

export function useGetFinanceApprovalLots(
  request: IFinanceApprovalLotsRequest,
  enabled: boolean 
) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IFinanceApprovalLotsResponse>
  >({
    queryKey: [...FINANCE_APPROVAL_QUERY_KEY, request],
    queryFn: () => FinanceApprovalService.getFinanceApprovalLots(request),
    enabled: enabled
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    lots: data?.data?.data || [],
    totalCount: data?.data?.pagination.totalCount || 0,
    isFetching: isLoading,
    isError,
  };
}
